import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent {
  isYearly = false;
  isCompareModalOpen = false;

  toggleBilling() {
    this.isYearly = !this.isYearly;
  }

  openCompareModal() {
    this.isCompareModalOpen = true;
    document.body.style.overflow = 'hidden';
  }

  closeCompareModal() {
    this.isCompareModalOpen = false;
    document.body.style.overflow = 'auto';
  }

  featureGroups = [
    {
      name: 'Plan Details & Limits',
      features: [
        { name: 'Users Included', starter: '2', growth: '5', business: '10', enterprise: 'Custom (Upon Agreement)' },
        { name: 'Branches', starter: '1 branch max', growth: 'Up to 2 branches', business: 'Up to 5 branches', enterprise: 'Unlimited' },
        { name: 'Setup Fee', starter: '2,500 SAR', growth: '3,500 SAR', business: '7,500 SAR', enterprise: 'Depends on the project' }
      ]
    },
    {
      name: 'Features Included',
      features: [
        { name: 'Multiple UI Languages', starter: 'no', growth: 'yes', business: 'yes', enterprise: 'yes' },
        { name: 'Multiple Currencies', starter: 'no', growth: 'yes', business: 'yes', enterprise: 'yes' },
        { name: 'Multiple Companies', starter: 'no', growth: 'yes', business: 'yes', enterprise: 'yes' },
        { name: '24/7 Technical Support', starter: 'yes', growth: 'yes', business: 'yes', enterprise: 'yes' },
        { name: 'Monthly Backup', starter: 'no', growth: 'no', business: 'yes', enterprise: 'yes' },
        { name: 'Backup Control', starter: 'no', growth: 'no', business: 'yes', enterprise: 'yes' },
        { name: 'API Integration Access', starter: 'no', growth: 'no', business: 'yes', enterprise: 'yes' },
        { name: 'API Documentation', starter: 'no', growth: 'no', business: 'yes', enterprise: 'yes' }
      ]
    },
    {
      name: 'Add-ons Available',
      features: [
        { name: 'Additional User Add-on', starter: '30 SAR/month (monthly) or 25 SAR/month (annual)', growth: '30 SAR/month (monthly) or 25 SAR/month (annual)', business: '30 SAR/month (monthly) or 25 SAR/month (annual)', enterprise: '30 SAR/month (monthly) or 25 SAR/month (annual)' },
        { name: 'Additional Branch Add-on', starter: 'no', growth: '150 SAR/month (monthly) or 125 SAR/month (annual)', business: '150 SAR/month (monthly) or 125 SAR/month (annual)', enterprise: '150 SAR/month (monthly) or 125 SAR/month (annual)' }
      ]
    }
  ];
}
